<template>
  <v-dialog v-model="sendbackPointsShow" persistent max-width="390">
    <v-card class="pa-6">
      <v-row class="ma-0">
        <v-text-field
          v-model="newSendbackText"
          label="新增退回原因"
          append-outer-icon="mdi-plus"
          @click:append-outer="add"
        ></v-text-field>
      </v-row>
      <v-chip-group
        v-model="checkedItems"
        column
        multiple
        active-class="primary--text"
        next-icon="mdi-plus"
      >
        <template v-for="(item, index) in sendbackPoints">
          <v-chip
            v-if="item.user_id === user.id"
            :key="index"
            :value="item.id"
            close
            @click:close="remove(item)"
            >{{ item.comment }}</v-chip
          >
          <v-chip v-else :key="index" :value="item.id">{{
            item.comment
          }}</v-chip>
        </template>
      </v-chip-group>
      <v-checkbox v-model="permit" label="允许学生查看批改内容"></v-checkbox>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="green darken-1"
          text
          :disabled="pendingConfirm"
          @click="close"
          >取消</v-btn
        >
        <v-btn color="primary" :disabled="pendingConfirm" @click="submit">
          确认
          <v-progress-circular
            v-if="pendingConfirm"
            indeterminate
            color="red"
            size="20"
          ></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../tianmuhu/api';
export default {
  data() {
    return {
      permit: false,
      newSendbackText: '',
      sendbackText_rules: [(value) => !!value || '必填.'],
      checkedItems: []
    };
  },
  computed: {
    ...mapGetters([
      'user',
      'sendbackPointsShow',
      'deduction',
      'sendbackPoints',
      'pendingConfirm',
      'elective',
      'canvasArray'
    ]),
    hasRecord() {
      return this.canvasArray.some((item) => {
        if (typeof item.canvas === 'string') {
          // 如果是序列化的字符串，解析后检查对象数量
          try {
            const json = JSON.parse(item.canvas);
            return json.objects && json.objects.length > 0;
          } catch (error) {
            return false;
          }
        } else if (item.canvas && item.canvas.getObjects) {
          // 如果是 Canvas 对象，直接检查
          return item.canvas.getObjects().length > 0;
        }
        return false;
      });
    }
  },
  mounted() {
    this.fetchSendbackPoints();
  },
  methods: {
    ...mapActions([
      'rotateReport',
      'updateReport',
      'addSendbackPoint',
      'fetchSendbackPoints',
      'deleteSendbackPoints',
      'reloadElective',
      'sendback',
      'alert'
    ]),
    uploadCanvas(rpt_status, notice, checkedItems) {
      const _this = this;
      const files = [];
      let processedCount = 0;

      // 处理画布的函数
      const processCanvas = (item, index) => {
        if (typeof item.canvas === 'string') {
          // 如果是序列化的字符串，需要先反序列化为 Canvas 对象
          try {
            const json = JSON.parse(item.canvas);
            const tempCanvas = new fabric.Canvas(null, {
              width: item.width || 800,
              height: item.height || 600
            });
            tempCanvas.loadFromJSON(json, function() {
              tempCanvas.setZoom(item.ratio);
              delete tempCanvas.backgroundImage;
              const h = tempCanvas.getHeight();
              const w = tempCanvas.getWidth();
              const url = tempCanvas
                .toDataURL({
                  format: 'png',
                  width: w,
                  height: h
                })
                .slice(22);
              files[index] = url;
              processedCount++;
              checkComplete();
            });
          } catch (error) {
            console.error('Canvas deserialization failed:', error);
            files[index] = '';
            processedCount++;
            checkComplete();
          }
        } else {
          // 如果是 Canvas 对象，直接处理
          const canvas = item.canvas;
          canvas.setZoom(item.ratio);
          delete canvas.backgroundImage;
          const h = canvas.getHeight();
          const w = canvas.getWidth();
          const url = canvas
            .toDataURL({
              format: 'png',
              width: w,
              height: h
            })
            .slice(22);
          files[index] = url;
          processedCount++;
          checkComplete();
        }
      };

      // 检查是否所有画布都处理完成
      const checkComplete = () => {
        if (processedCount === _this.canvasArray.length) {
          sendRequest();
        }
      };

      // 发送请求的函数
      const sendRequest = () => {
        const electiveId = _this.elective.id;
        const hasValidFiles = files.some(file => file && file !== '');

        _this.updateReport({
          id: electiveId,
          page: _this.canvasArray.length,
          student: _this.elective.user_id,
          status: rpt_status,
          commitTeacher: _this.user.id,
          files: hasValidFiles ? files : []
        }).then(() => {
          api.addSendback(
            electiveId,
            checkedItems,
            _this.permit,
            async () => {
              _this.alert({ message: '退回成功', color: 'success' });
              _this.reloadElective();
            },
            async (error) => {
              _this.alert({
                message: `退回失败，请稍后再试。`,
                color: 'error',
                debugInfo: error
              });
            }
          );
        });
      };

      // 如果没有画布，直接发送请求
      if (this.canvasArray.length === 0) {
        sendRequest();
        return;
      }

      // 初始化 files 数组
      for (let i = 0; i < this.canvasArray.length; i++) {
        files[i] = null;
      }

      // 处理所有画布
      this.canvasArray.forEach((item, index) => {
        processCanvas(item, index);
      });
    },
    add() {
      if (this.newSendbackText.trim() === '') {
        this.alert({ message: '新增退回原因不能为空', color: 'error' });
        return;
      }
      this.addSendbackPoint(this.newSendbackText).then(() => {
        this.newSendbackText = '';
      });
    },
    remove(item) {
      if (item.user_id !== this.user.id) {
        this.alert({ message: '该退回标签只能由创建者删除', color: 'error' });
        return;
      }
      this.$store.commit('setConfirmAction', async () => {
        await this.deleteSendbackPoints(item.id);
        this.$store.commit('setConfirm', '');
      });
      this.$store.commit('setConfirm', '您确定删除该退回标签吗？');
    },
    submit() {
      if (this.checkedItems.length === 0) {
        this.alert({ message: '请至少选择一个退回原因', color: 'error' });
        return;
      }
      const sendbackItems = this.checkedItems.map((x) => {
        const item = this.sendbackPoints.find(
          (s) => s.id.toString() === x.toString()
        );
        return item ? item.comment : '';
      });
      this.$store.commit('setConfirmAction', async () => {
        if (this.canvasArray.length === 0 || !this.hasRecord) {
          await this.sendback({
            elective: this.elective,
            checkedItems: sendbackItems.join(' | '),
            permit: this.permit
          });
        } else {
          const rotated = this.canvasArray.some((x) => {
            // 检查是否需要旋转（处理序列化和非序列化情况）
            if (typeof x.canvas === 'string') {
              try {
                const json = JSON.parse(x.canvas);
                return json.objects && json.objects.length > 0 && (x.rotateTimes % 4 !== 0);
              } catch (error) {
                return x.rotateTimes % 4 !== 0;
              }
            } else {
              return x.rotateTimes % 4 !== 0;
            }
          });

          if (rotated) {
            const rotateTimes = this.canvasArray.map((palette) => {
              return palette.rotateTimes;
            });

            this.rotateReport({
              id: this.elective.id,
              rotateTimes: rotateTimes
            }).then(() => {
              _this.uploadCanvas(
                'Re',
                '报告提交成功',
                sendbackItems.join(' | ')
              );
            });
          } else {
            this.uploadCanvas('Re', '报告提交成功', sendbackItems.join(' | '));
          }
        }
        this.$store.commit('setConfirm', '');
        this.close();
      });
      this.$store.commit('setConfirm', '您确定告知该同学重新提交报告吗？');
    },
    close() {
      this.$store.commit('setSendbackPointsShow', !this.sendbackPointsShow);
      this.checkedItems = [];
    }
  }
};
</script>
